export default __webpack_public_path__ + "static/media/no-img.9a2ad091.jpg";